<template>
	<front-admin-hub module-key="settings" />
</template>
<script>
import FrontAdminHub from '@/components/FrontAdminHub/index.vue';
export default {
	name: 'SettingsManage',
	components: { FrontAdminHub },
};
</script>
